import React from 'react';
import { 
  Bell, 
  Search, 
  FileText, 
  BookOpen, 
  Clock, 
  BarChart2, 
  PlayCircle, 
  Car, 
  Gift, 
  ShoppingBag, 
  Share2, 
  Home, 
  CreditCard,
  LayoutGrid
} from 'lucide-react';

const CredHomePage = () => {
  return (
    <div className="bg-[#f8f8f8] min-h-screen pb-24 font-sans text-gray-900">
      {/* Top Header */}
      <header className="flex justify-between items-center px-5 py-4 bg-white sticky top-0 z-20 shadow-sm">
        <div className="flex items-center gap-3">
          <div className="w-10 h-10 rounded-full bg-gray-200 overflow-hidden border border-gray-300">
            <img src="https://ui-avatars.com/api/?name=User&background=0D8ABC&color=fff" alt="Profile" className="w-full h-full object-cover" />
          </div>
        </div>
        
        <div className="bg-yellow-50 border border-yellow-200 text-yellow-800 text-xs font-bold px-4 py-1.5 rounded-full flex items-center gap-2">
          <span className="w-2.5 h-2.5 bg-yellow-400 rounded-full inline-block"></span>
          pro members only
        </div>

        <div className="flex items-center gap-4">
          <Search className="w-6 h-6 text-gray-700 cursor-pointer" />
          <div className="relative cursor-pointer">
            <Bell className="w-6 h-6 text-gray-700" />
            <span className="absolute top-0 right-0 w-2.5 h-2.5 bg-red-500 border-2 border-white rounded-full"></span>
          </div>
        </div>
      </header>

      <main className="px-5 pt-6 space-y-10">
        {/* Live News Section */}
        <section>
          <p className="text-[11px] font-bold text-gray-500 uppercase tracking-[0.2em] mb-3">Now Live</p>
          <div className="flex justify-between items-start mb-4">
            <h2 className="text-xl font-extrabold text-gray-900 leading-tight">
              Latest breaking news <br/> member exclusive
            </h2>
            <button className="bg-white border border-gray-900 text-gray-900 px-4 py-2 rounded-lg font-bold text-xs shadow-sm hover:bg-gray-50 transition-colors">
              Read Now
            </button>
          </div>
          
          <div className="bg-gradient-to-br from-[#4a1c1c] to-black rounded-[1.5rem] h-52 p-6 relative overflow-hidden shadow-xl flex flex-col justify-center items-center text-white">
            <p className="text-red-400 text-xs font-semibold tracking-[0.3em] mb-2 z-10">THE WORLDEYE</p>
            <h3 className="text-3xl font-extrabold tracking-widest z-10 flex items-center gap-2">
              LIVE NOW <span className="w-2 h-2 bg-red-500 rounded-full animate-pulse"></span>
            </h3>
            <p className="mt-8 text-[10px] text-gray-300 tracking-[0.2em] z-10">CURATED BY EDITORS</p>
            <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent"></div>
          </div>
        </section>

        {/* Quiz Section */}
        <section>
          <div className="flex justify-between items-center mb-5">
             <p className="text-[11px] font-bold text-gray-500 uppercase tracking-[0.2em]">Quiz Area</p>
          </div>
          <div className="flex justify-between items-start">
            {[
              { icon: FileText, label: 'Today Tests' },
              { icon: BookOpen, label: 'My Homework' },
              { icon: Clock, label: 'Upcoming Tests' },
              { icon: BarChart2, label: 'Results' },
              { icon: PlayCircle, label: 'Practice' },
            ].map((item, idx) => (
              <div key={idx} className="flex flex-col items-center gap-3 w-[72px] cursor-pointer group">
                <div className="w-16 h-16 bg-white rounded-full shadow-[0_4px_15px_rgba(0,0,0,0.05)] border border-gray-100 flex items-center justify-center group-hover:shadow-[0_4px_15px_rgba(0,0,0,0.1)] transition-all group-hover:scale-105">
                  <item.icon className="w-7 h-7 text-gray-800" strokeWidth={1.5} />
                </div>
                <span className="text-[10px] font-bold text-center text-gray-700 leading-tight group-hover:text-black">
                  {item.label}
                </span>
              </div>
            ))}
          </div>
        </section>

        {/* Explore Section */}
        <section>
          <div className="flex justify-between items-center mb-5">
             <p className="text-[11px] font-bold text-gray-500 uppercase tracking-[0.2em]">Explore</p>
             <button className="text-[11px] text-gray-500 font-bold flex items-center hover:text-gray-900 transition-colors">
               view all &gt;
             </button>
          </div>
          <div className="flex flex-wrap gap-3">
            {[
              { icon: Car, label: 'garage', color: 'text-gray-700' },
              { icon: Gift, label: 'rewards', color: 'text-pink-500' },
              { icon: ShoppingBag, label: 'shop', color: 'text-blue-500' },
              { icon: Share2, label: 'refer', color: 'text-purple-500' },
              { icon: Home, label: 'rent', color: 'text-orange-500' },
              { icon: CreditCard, label: 'gift cards', color: 'text-indigo-500' },
            ].map((item, idx) => (
              <div key={idx} className="bg-white border border-gray-200 rounded-full px-5 py-2.5 flex items-center gap-2 shadow-sm cursor-pointer hover:bg-gray-50 hover:shadow-md transition-all">
                <item.icon className={`w-4 h-4 ${item.color}`} strokeWidth={2} />
                <span className="text-[13px] font-bold text-gray-800">{item.label}</span>
              </div>
            ))}
          </div>
        </section>

        {/* Ads Section */}
        <section className="space-y-4">
          <div className="border-t border-dashed border-gray-300 pt-6 mb-6"></div>
          
          <div className="bg-[#1a1a1a] rounded-3xl p-6 shadow-xl relative overflow-hidden flex flex-col items-start min-h-[160px] justify-center cursor-pointer">
             <div className="absolute right-0 top-0 opacity-10 w-48 h-48 bg-yellow-500 rounded-full -mr-16 -mt-16 blur-2xl"></div>
             
             <div className="flex items-start gap-4 z-10 w-full">
               <div className="w-14 h-14 rounded-2xl bg-gray-800 border border-gray-700 flex flex-col items-center justify-center shrink-0">
                 <span className="text-yellow-500 font-bold text-[10px] uppercase tracking-wider">AD</span>
                 <ShoppingBag className="w-6 h-6 text-white mt-1" strokeWidth={1.5} />
               </div>
               
               <div className="flex-1">
                 <h3 className="text-white text-lg font-bold mb-1">Exclusive App Offer</h3>
                 <p className="text-gray-400 text-xs mb-4 font-medium">pay your bill. pick your prize.</p>
                 <button className="bg-gradient-to-b from-yellow-400 to-yellow-600 text-black px-6 py-2.5 rounded-lg font-extrabold text-xs shadow-sm">
                   Claim now
                 </button>
               </div>
             </div>
          </div>

          <div className="bg-[#1a1a1a] rounded-3xl p-6 shadow-xl relative overflow-hidden flex flex-col items-start min-h-[160px] justify-center cursor-pointer">
             <div className="absolute right-0 bottom-0 opacity-10 w-48 h-48 bg-blue-500 rounded-full -mr-16 -mb-16 blur-2xl"></div>
             
             <div className="flex items-start gap-4 z-10 w-full">
               <div className="w-14 h-14 rounded-2xl bg-gray-800 border border-gray-700 flex flex-col items-center justify-center shrink-0">
                 <span className="text-blue-500 font-bold text-[10px] uppercase tracking-wider">PRO</span>
                 <LayoutGrid className="w-6 h-6 text-white mt-1" strokeWidth={1.5} />
               </div>
               
               <div className="flex-1">
                 <h3 className="text-white text-lg font-bold mb-1">Upgrade your storage</h3>
                 <p className="text-gray-400 text-xs mb-4 font-medium">Save more files with 100GB extra.</p>
                 <button className="bg-white text-black px-6 py-2.5 rounded-lg font-extrabold text-xs shadow-sm">
                   Upgrade
                 </button>
               </div>
             </div>
          </div>
        </section>

      </main>

      {/* Bottom Navigation */}
      <nav className="fixed bottom-0 w-full bg-black text-white h-[88px] flex justify-between items-center px-6 z-50 rounded-t-[2.5rem] shadow-[0_-10px_40px_rgba(0,0,0,0.4)]">
        <div className="flex flex-col items-center gap-1.5 cursor-pointer">
          <Home className="w-7 h-7 text-white" strokeWidth={2} />
          <span className="text-[9px] font-bold tracking-[0.1em] opacity-100">HOME</span>
        </div>
        
        <div className="flex flex-col items-center gap-1.5 text-gray-500 cursor-pointer hover:text-white transition-colors">
          <FileText className="w-7 h-7" strokeWidth={1.5} />
          <span className="text-[9px] font-bold tracking-[0.1em]">STORAGE</span>
        </div>
        
        <div className="relative -top-6 cursor-pointer transform hover:scale-105 transition-transform">
           <div className="w-20 h-20 rounded-full bg-gradient-to-b from-gray-600 to-[#111] p-[2px] shadow-2xl flex items-center justify-center">
              <div className="w-full h-full rounded-full border border-gray-700 flex items-center justify-center bg-black bg-gradient-to-br from-[#222] to-black">
                 <span className="font-extrabold text-xl italic tracking-wider text-white">QUIZ</span>
              </div>
           </div>
        </div>

        <div className="flex flex-col items-center gap-1.5 text-gray-500 cursor-pointer hover:text-white transition-colors">
          <div className="relative">
            <span className="absolute -top-1 -right-1 w-2.5 h-2.5 bg-yellow-600 rounded-full"></span>
            <Gift className="w-7 h-7" strokeWidth={1.5} />
          </div>
          <span className="text-[9px] font-bold tracking-[0.1em]">REWARDS</span>
        </div>
        
        <div className="flex flex-col items-center gap-1.5 text-gray-500 cursor-pointer hover:text-white transition-colors">
          <LayoutGrid className="w-7 h-7" strokeWidth={1.5} />
          <span className="text-[9px] font-bold tracking-[0.1em]">MORE</span>
        </div>
      </nav>
    </div>
  );
};

export default CredHomePage;
